import { notify } from "./notification";

export const bytesToString = (bytes: number): string => {
  let incrementor = 0;
  let size = bytes;
  do {
    incrementor++;
    size = size / 1024;
  } while (size >= 1024);

  let prefix = "";
  incrementor === 0 && (prefix = "B");
  incrementor === 1 && (prefix = "KB");
  incrementor === 2 && (prefix = "MB");
  incrementor === 3 && (prefix = "GB");

  return size.toFixed(2) + " " + prefix;
};

export const copyToClipboard = (text: string): void => {
  navigator.clipboard.writeText(text);
  notify("Copied To Clipboard", "success");
};

export const downloadFileFromURL = async (
  url: string,
  filename: string = "untitled"
): Promise<void> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  } catch (error) {
    console.error(error);
  }
};

export const clipText = (
  text: string,
  limit: number,
  subStringLength: number = 6
): string => {
  let returntext = text;
  if (text?.length > limit) {
    returntext =
      text.substring(0, subStringLength) +
      "...." +
      text.substring(text.length - subStringLength);
  }

  return returntext;
};

export const delayFunction = (milliseconds: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const getItemsPerPage = (
  containerRef: any,
  rowHeight: number
): number => {
  const tableHeight = containerRef?.current?.clientHeight || 0;
  return Math.floor(tableHeight / rowHeight) - 1;
};

export const getGridItemsPerPage = (
  containerRef: any,
  gridSize: number
): number => {
  const gridHeight = containerRef?.current?.clientHeight;
  const gridWidth = containerRef?.current?.clientWidth;

  const rowItems = Math.floor(gridWidth / gridSize);
  const colItems = Math.floor(gridHeight / gridSize);
  return rowItems * colItems;
};

export const emailValidator = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};


export const normalizeTimestamp = (timestamp: number) => {
  return timestamp < 1e12 ? timestamp * 1000 : timestamp;
};